<template>
  <article class="gallery-section">
    <header v-if="name">
      <h2>{{ name }}</h2>
    </header>

    <section class="banners" :class="section_classes">
      <gallery-banner
        v-for="banner in banners"
        :key="banner.basename()"
        :banner="banner"
        :compact="compact"
      ></gallery-banner>
    </section>
  </article>
</template>

<script>
import GallerySection from '../structure/Resources/GallerySection';
import GalleryBanner from './GalleryBanner.vue';

const ALIGNMENT_THRESHOLD = 500;

export default {
  props: {
    section: {
      type: GallerySection,
      required: true,
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    name() {
      return this.section.name();
    },

    banners() {
      return this.section.banners();
    },

    section_classes() {
      const classes = [];

      if (this.banners[0].resource().width() <= ALIGNMENT_THRESHOLD) {
        classes.push('small');
      }

      if (this.section.shouldStack()) {
        classes.push('stacked');
      }

      return classes;
    },
  },

  components: {
    GalleryBanner,
  },
};
</script>

<style lang="scss" scoped>
.gallery-section {
  margin-bottom: 3rem;
}

header {
  background: #444;
  border-radius: 4px;
  padding: 1rem 2rem;
  margin: 2rem 0;

  h2 {
    color: #fafafa;
    margin: 0;
    padding: 0;
  }

  @include dark {
    background: #888;

    h2 {
      color: #222;
    }
  }
}

.banners {
  display: flex;
  flex-flow: row wrap;
  align-items: flex-start;
  justify-content: space-around;

  &.stacked {
    flex-direction: column;
    justify-content: flex-start;
  }

  &.small {
    justify-content: flex-start;
  }
}
</style>
